import { useDispatch, useSelector } from 'react-redux';

import { doRequest } from '@r1-frontend/do-request';
import { byShopItemId } from '@r1-frontend/api-domru/api-vas/v1/vas';
import { IVas } from '@r1-frontend/api-domru/api-vas/v1/vas/byShopItemId/dto/responseDto';
import { ISpecOffer } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/dto/ISpecOffer';

import { setTariff } from '~/src/entities/speed-bonus/context/actions';
import { initialize } from '~/src/entities/speed-bonus/context/actions/thunk';
import { Plus100Status } from '~/src/entities/speed-bonus/context/constants';
import { useContextDispatch } from '~/src/entities/speed-bonus/context/hooks';
import { setIsPopupOpened, setPopupState } from '~/src/features/specialOffersContainer/store/actions';
import { loadOffers } from '~/src/features/specialOffersContainer/store/actions/thunk';
import { TState } from '~/src/store';
import { getConfirmedPhones } from '~/src/store/selectors/auth';

export const useConnectSpeedBonus = () => {
    const dispatch = useDispatch();
    const speedBonusDispatch = useContextDispatch();

    const { agreementId, confirmedPhones } = useSelector((state: TState) => ({
        agreementId: state.auth.clientPersonal?.agreementId,
        confirmedPhones: getConfirmedPhones(state),
    }));

    const errorHandler = () => {
        dispatch(setIsPopupOpened(false));
        dispatch(setPopupState('connectionError'));
    };

    return async(navigation: ISpecOffer['navigation']) => {
        if (!navigation?.shopItemId) {
            return;
        }

        const response = await doRequest.apiVas<IVas>(
            byShopItemId(navigation.shopItemId),
        );

        if (response.isSuccess) {
            const currentSpeedBonus = response.payload.variants.find(({ globalId }) => globalId === navigation.id);

            if (currentSpeedBonus) {
                const {
                    socId,
                    globalId,
                    status = Plus100Status,
                    specialOfferRequestId,
                    speed,
                    title,
                    price,
                    connectionFlow,
                    shopItemId,
                } = currentSpeedBonus;

                speedBonusDispatch(setTariff({
                    socId,
                    bonusId: globalId,
                    speedBonusStatus: Number(status),
                    specialOffersRequestIds: specialOfferRequestId ? [specialOfferRequestId] : undefined,
                    speed,
                    title,
                    price: price.full,
                    connectionFlow,
                    shopItemId,
                }));
                speedBonusDispatch(initialize({
                    agreementId,
                    contactId: confirmedPhones?.[0].contactId,
                    beforeSwitchToConnection: () => dispatch(setIsPopupOpened(false)),
                    afterSuccessConnection: () => dispatch(loadOffers()),
                }));
            } else {
                errorHandler();
            }
        } else {
            errorHandler();
        }
    };
};
